import React from "react";
import { LandingPaymentInfo } from "../common";
import { PaymentOpenItems } from "../../common/open-items";
import { Collection } from "@type-r/models/lib/collection";

export const PendingUnreconciledPayments = ({payments}:{payments : Collection<LandingPaymentInfo>}) => {

    const unreconciledPaymentsTotalCount = payments.reduce((curr: number, sum) => curr + sum.count, 0)

    return (<PaymentOpenItems
                title={`Open Items - (${unreconciledPaymentsTotalCount})`}
                payments={payments}
                linkUrl='inmatch/matching/unreconciled'
                type='unreconciled' />
    );
}
